const bodyType = ["body4", "body5", "body6"];

export const FontLinkAfterStyle = (type: string): string => {
  return `
    content: "";
    position: absolute;
    left: 0;
    width: 0;

    // TODO: use this when we switch to new fonts
    // bottom: ${bodyType.includes(type) ? "5px" : "6px"};
    bottom: 2px;
    
    background-color: currentColor;
    height: 1px;
    transition-property: width;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
  `;
};

export const FontLinkHoverStyle = `
    width: 100%;
`;

export const FontLinkStyle = (type: string): string => {
  return `
  text-decoration: none;
  position: relative;
  display: block;
  width: fit-content;
   
  &::after {
    ${FontLinkAfterStyle(type)}
  }
  
  &:hover::after { 
    ${FontLinkHoverStyle}
  }
`;
};
